import { API_CONFIG, apiUtils } from '../config.js';

export const wabaApi = {
  // Initialize WABA templates
  // Payload: { orgId, wabaId, userId }
  initWaba: async (data) => {
    const url = `${API_CONFIG.BASE_URL}/whatsapp/waba/init`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
};

export default wabaApi;
